import { ProductPageLayout } from '../components/ProductPageLayout';

export function AiInfluencerMotionBuilderPage() {
    return <ProductPageLayout productId="ai-influencer-motion-builder" />;
}
